import { render, staticRenderFns } from "./serveIncome.vue?vue&type=template&id=ff385e98&scoped=true&"
import script from "./serveIncome.vue?vue&type=script&lang=js&"
export * from "./serveIncome.vue?vue&type=script&lang=js&"
import style0 from "./serveIncome.vue?vue&type=style&index=0&id=ff385e98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff385e98",
  null
  
)

export default component.exports